import { config } from "../config.js";

// 視点の切り替え(2026-10-30 オーナー要望「主観・追尾・斜め見下ろしの3段階で切り替えられるとよい」)。見た目だけ。
// 値は config.graphics.cameras(後ろへの距離・高さ・見る先は倍率1のときの値)。
// 主観以外は、スケール感の倍率(world.scale)どおりに引き、視野角を広げる(src/sim/scale.js)。

export const CAMERA_MODES = config.graphics.cameras.order;

// mode の視点で、カメラの位置と見る先と視野角を決める。baseFov: 倍率1のときの視野角(画面の向きで変わる)。
// wide: 縦長の画面か(左右がほぼ自機に付いていく)
export function cameraFor(world, mode, baseFov, wide) {
  const c = config.graphics.cameras[mode] || config.graphics.cameras.chase;
  const p = world.player;
  const s = world.scale || 1;
  const fov = Math.min(config.scale.maxFov, baseFov + (c.fovAdd || 0) + (s - 1) * config.scale.fovPerScale);
  if (mode === "cockpit") {
    // 主観: 自機の位置から前を見る(自機は描かない)。自機の大きさは変わらないので、位置には倍率を掛けない
    return { x: p.x, y: p.y + c.up, z: c.back, lx: p.x, ly: p.y + c.up, lz: c.lookZ * s, fov, hidePlayer: true };
  }
  const f = c.follow;
  const fx = wide ? f : 0.95;
  return {
    x: p.x * fx,
    y: p.y * f + c.up * s,
    z: c.back * s,
    lx: p.x * fx * 0.8,
    ly: p.y * f * 0.8 + c.lookY * s,
    lz: c.lookZ * s,
    fov,
    hidePlayer: false,
  };
}
